export default "__VITE_ASSET__Diea3Jb4__"